module.exports = __webpack_public_path__ + "static/media/location-pin.7ad75e31.svg";